var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "template-setup" }, [
    _c("div", { staticClass: "section-card" }, [
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("whatsapp_business_api.setupYourTemplate"))),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "description" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("whatsapp_business_api.setupDescription")) +
            "\n            "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://developers.facebook.com/docs/whatsapp/message-templates/guidelines",
              target: "_blank",
            },
          },
          [_vm._v(_vm._s(_vm.$t("whatsapp_business_api.learnMoreCategories")))]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category-tabs" }, [
        _c(
          "div",
          {
            staticClass: "category-tab",
            class: {
              active: _vm.form.category === "MARKETING",
              disabled: _vm.isCategoryDisabled,
            },
            on: {
              click: function ($event) {
                !_vm.isCategoryDisabled && _vm.selectCategory("MARKETING")
              },
            },
          },
          [
            _c("span", { staticClass: "material-icons" }, [_vm._v("campaign")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("whatsapp_business_api.marketing"))),
            ]),
            _vm._v(" "),
            _vm.isCategoryDisabled
              ? _c(
                  "a-tooltip",
                  {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.categoryCannotChangeApproved"
                      ),
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "material-icons",
                        staticStyle: {
                          "font-size": "16px",
                          "margin-left": "4px",
                        },
                      },
                      [_vm._v("info")]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "category-tab",
            class: {
              active: _vm.form.category === "UTILITY",
              disabled: _vm.isCategoryDisabled,
            },
            on: {
              click: function ($event) {
                !_vm.isCategoryDisabled && _vm.selectCategory("UTILITY")
              },
            },
          },
          [
            _c("span", { staticClass: "material-icons" }, [_vm._v("build")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("whatsapp_business_api.utility"))),
            ]),
            _vm._v(" "),
            _vm.isCategoryDisabled
              ? _c(
                  "a-tooltip",
                  {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.categoryCannotChangeApproved"
                      ),
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "material-icons",
                        staticStyle: {
                          "font-size": "16px",
                          "margin-left": "4px",
                        },
                      },
                      [_vm._v("info")]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "category-tab",
            class: {
              active: _vm.form.category === "AUTHENTICATION",
              disabled: _vm.isCategoryDisabled,
            },
            on: {
              click: function ($event) {
                !_vm.isCategoryDisabled && _vm.selectCategory("AUTHENTICATION")
              },
            },
          },
          [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v("verified_user"),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("whatsapp_business_api.authentication"))),
            ]),
            _vm._v(" "),
            _vm.isCategoryDisabled
              ? _c(
                  "a-tooltip",
                  {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.categoryCannotChangeApproved"
                      ),
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "material-icons",
                        staticStyle: {
                          "font-size": "16px",
                          "margin-left": "4px",
                        },
                      },
                      [_vm._v("info")]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.isCategoryDisabled
        ? _c(
            "div",
            {
              staticClass: "edit-mode-notice",
              staticStyle: {
                "margin-top": "12px",
                padding: "12px",
                background: "#fff7e6",
                border: "1px solid #ffd591",
                "border-radius": "4px",
                color: "#ad6800",
                "font-size": "13px",
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "material-icons",
                  staticStyle: {
                    "font-size": "16px",
                    "vertical-align": "middle",
                    "margin-right": "4px",
                  },
                },
                [_vm._v("info")]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("whatsapp_business_api.categoryCannotEditApproved")
                  )
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "template-types" },
        _vm._l(_vm.templateTypes, function (type) {
          return _c(
            "a-tooltip",
            {
              key: type.id,
              attrs: {
                title: type.disabled ? type.disabledReason : "",
                mouseEnterDelay: 0.5,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "template-type-option",
                  class: {
                    selected: _vm.form.templateType === type.id,
                    disabled: type.disabled,
                  },
                  on: {
                    click: function ($event) {
                      !type.disabled && _vm.selectTemplateType(type.id)
                    },
                  },
                },
                [
                  _c("a-radio", {
                    attrs: {
                      checked: _vm.form.templateType === type.id,
                      disabled: type.disabled,
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "type-info" }, [
                    _c(
                      "span",
                      { staticClass: "type-label" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(type.label) +
                            "\n                            "
                        ),
                        type.disabled
                          ? _c(
                              "a-tag",
                              {
                                staticStyle: {
                                  "margin-left": "8px",
                                  "font-size": "11px",
                                },
                                attrs: { color: "orange" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("whatsapp_business_api.notSupported")
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "type-desc" }, [
                      _vm._v(_vm._s(type.description)),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.form.templateType === "CATALOGUE"
        ? _c(
            "div",
            {
              staticClass: "catalogue-subtypes",
              staticStyle: { "margin-top": "24px" },
            },
            [
              _c(
                "h4",
                {
                  staticStyle: {
                    "margin-bottom": "12px",
                    "font-size": "14px",
                    color: "#666",
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("whatsapp_business_api.selectProductMessageType")
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "template-types" },
                _vm._l(_vm.catalogueSubtypes, function (subType) {
                  return _c(
                    "a-tooltip",
                    {
                      key: subType.id,
                      attrs: {
                        title: subType.disabled ? subType.disabledReason : "",
                        mouseEnterDelay: 0.5,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "template-type-option",
                          class: {
                            selected: _vm.form.catalogueSubType === subType.id,
                            disabled: subType.disabled,
                          },
                          on: {
                            click: function ($event) {
                              !subType.disabled &&
                                _vm.selectCatalogueSubType(subType.id)
                            },
                          },
                        },
                        [
                          _c("a-radio", {
                            attrs: {
                              checked: _vm.form.catalogueSubType === subType.id,
                              disabled: subType.disabled,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "type-info" }, [
                            _c(
                              "span",
                              { staticClass: "type-label" },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(subType.label) +
                                    "\n                                "
                                ),
                                subType.disabled
                                  ? _c(
                                      "a-tag",
                                      {
                                        staticStyle: {
                                          "margin-left": "8px",
                                          "font-size": "11px",
                                        },
                                        attrs: { color: "orange" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "whatsapp_business_api.notSupported"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "type-desc" }, [
                              _vm._v(_vm._s(subType.description)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.form.category === "AUTHENTICATION"
        ? _c(
            "div",
            {
              staticClass: "authentication-subtypes",
              staticStyle: { "margin-top": "24px" },
            },
            [
              _c(
                "h4",
                {
                  staticStyle: {
                    "margin-bottom": "12px",
                    "font-size": "14px",
                    color: "#666",
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("whatsapp_business_api.selectOtpAutofillType")
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "template-types" },
                _vm._l(_vm.authenticationSubtypes, function (subType) {
                  return _c(
                    "div",
                    {
                      key: subType.id,
                      staticClass: "template-type-option",
                      class: {
                        selected:
                          _vm.form.authentication.otpSubType === subType.id,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectAuthSubType(subType.id)
                        },
                      },
                    },
                    [
                      _c("a-radio", {
                        attrs: {
                          checked:
                            _vm.form.authentication.otpSubType === subType.id,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "type-info" }, [
                        _c("span", { staticClass: "type-label" }, [
                          _vm._v(_vm._s(subType.label)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "type-desc" }, [
                          _vm._v(_vm._s(subType.description)),
                        ]),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }